// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-chart[data-v-176bd780]{margin:.4em 0;width:100%;max-width:30rem}.md-chart.is-wide[data-v-176bd780]{max-width:none}.md-chart-canvas[data-v-176bd780]{min-height:9rem}.md-chart-error[data-v-176bd780]{display:flex;align-items:center;gap:.4em;padding:.6em .8em;border:1px solid #f1c40f;background:#fffbea;border-radius:6px;color:#92720a;font-size:.85rem}", ""]);
// Exports
module.exports = exports;
